import { FC } from 'react'
import { userSlice } from 'user'
import { UploadItem } from '@wellesley/uploads'
import { useSelector } from 'react-redux'
import { UploadFileProps } from '@wellesley/ui'

import AddMediaButton from './AddMediaButton'
import { platformSettingsSlice } from '@wellesley/settings'

export type TAddMedia = {
  uploads: UploadItem[]
  isDisabled: boolean
  onAddMedia(this: void, props: UploadFileProps[]): void
}

const AddMedia: FC<TAddMedia> = ({ uploads, isDisabled, onAddMedia }) => {
  const currentUser = useSelector(userSlice.selectors.selectCurrentUser)

  const uploadsLimit = useSelector(
    platformSettingsSlice.selectors.selectPostConfig,
  ).max_media_attachments

  const canUpload = uploads.length < uploadsLimit

  return (
    <AddMediaButton
      {...{ canUpload }}
      onAddMedia={onAddMedia}
      isDisabled={isDisabled || !currentUser || !canUpload}
    />
  )
}

export default AddMedia
